var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.7,
    height: 86.9,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#f64c71}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st0",
    d: "M27.5 24.6h16.6c6.7-10.8 0 3 10-19.2.9-1.9 0-4.1-1.9-5-.5-.2-1-.3-1.6-.3h-6c-1.9 0-3.5 1.3-3.8 3.2l-.7 4.4c-.4 2.4-2.7 4.1-5.1 3.7-1.9-.3-3.4-1.8-3.7-3.7l-.7-4.5C30.4 1.3 28.8 0 26.9 0h-6c-2.1 0-3.8 1.7-3.8 3.8 0 .5.1 1.1.3 1.6 9.9 21.7 3.6 8.7 10.1 19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st0",
    d: "M26.4 79.3h18.9c1 0 1.9.8 1.9 1.9V85c0 1-.8 1.9-1.9 1.9H26.4c-1 0-1.9-.8-1.9-1.9v-3.8c0-1 .8-1.9 1.9-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st0",
    d: "M45.3 75.6c.2 0 .5-.1.7-.2-9.6-4.7-9.4-5.4-20.3 0 .5.2-.7.2 19.6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st0",
    d: "M33.3 32.1c7 0 5.7.8 8.5-3.8H29.9c1.8 3 2.1 3.8 3.4 3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st0",
    d: "M67.4 37.6c2-7-2.2-14.3-9.2-16.3-1.4-.4-2.8-.5-4.2-.5-1.9 0-3.8 1-4.8 2.7-8.4 13.4-6.2 12.4-16 12.4-1.9 0-3.8-1-4.8-2.7l-6.1-9.8c-4.5-7.2-22 .8-18.2 14.1-5.3 5-5.7 13.3-.7 18.7l.7.7c-2 7 2.2 14.3 9.2 16.3 1.3.4 2.7.5 4 .5 8.9 0 14.2-9.7 25.2-4.2 5.2 2.6 7.6 4.2 11.7 4.2 7.4.2 13.5-5.5 13.8-12.7 0-1.4-.1-2.7-.5-4 5.3-5 5.6-13.3.6-18.7-.2-.3-.4-.5-.7-.7zM25.1 59.8c-3.5 3.3-9.1 3.3-12.6 0-.7-.8-.6-2 .2-2.7.8-.7 2-.6 2.7.2 2 1.6 4.9 1.6 6.9 0 .7-.8 1.9-.8 2.7-.1.7.8.8 1.9.1 2.6zm0-16.9c-3.5 3.3-9.1 3.3-12.6 0-.7-.8-.6-2 .2-2.7s2-.6 2.7.2c2 1.6 4.9 1.6 6.9 0 .7-.8 1.9-.8 2.7-.1.7.7.8 1.8.1 2.6zm17 7.5c-3.5 3.4-9.1 3.4-12.6 0-.7-.8-.6-2 .2-2.7.8-.7 2-.6 2.7.2 2 1.6 4.9 1.6 6.9 0 .7-.8 1.9-.9 2.7-.2.7.7.8 1.9.1 2.7zm17 9.4c-3.5 3.4-9.1 3.4-12.6 0-.7-.8-.5-2 .3-2.7.8-.6 1.9-.5 2.6.2 2 1.6 4.9 1.6 6.9 0 .7-.8 1.9-.9 2.7-.2.7.7.8 1.9.1 2.7zm0-16.9c-3.5 3.4-9.1 3.4-12.6 0-.7-.8-.5-2 .3-2.7.8-.6 1.9-.5 2.6.2 2 1.6 4.9 1.6 6.9 0 .7-.8 1.9-.9 2.7-.2.7.6.8 1.8.1 2.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.3faa68359bfb5cd0b7b223a11a475c59.svg";
export { ForwardRef as ReactComponent };